export enum EventType {
  TrestleTokenFetched = "onTrestleTokenFetched",
}
